/* RESPONSIBLE TEAM: team-frontend-tech */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file 🚀 */
/* eslint-disable ember/no-classic-classes */
import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
export default Route.extend({
  customerService: service(),

  activate() {
    this.customerService.refreshCustomer();
  },
  redirect() {
    let guideRoute = this.routeName.replace(/about/, 'guide');
    this.replaceWith(guideRoute);
  },
});
